import { hsla, rgba } from 'polished'
import merge from 'lodash.merge'
import theme from 'styles/theme'

import { SYSTEM_FONT } from 'styles/theme/typography'

const stripeInputStyle = () => ({
  base: {
    fontFamily: `Marfa, ${SYSTEM_FONT}`,
    fontSize: theme.fontSizes.small,
    fontSmoothing: 'antialiased',
    '::placeholder': {
      color: hsla(0, 0, 0, 0.55),
      opacity: 1,
    },
  },
  invalid: {
    color: theme.colors.black,
  },
})

export const invalidStyles = () =>
  merge({}, stripeInputStyle(), {
    base: {
      '::placeholder': {
        color: rgba(theme.colors.negative, 0.5),
      },
    },
  })

export default stripeInputStyle
